var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSignin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Icon_-_Signin",
    width: 24,
    height: 24,
    "data-name": "Icon - Signin",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-1,.prefix__cls-2{fill:none}.prefix__cls-2{stroke:#31af50;stroke-width:2px}.prefix__cls-4{stroke:none}\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2520",
    d: "M0 0H24V24H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 2520"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_5971",
    "data-name": "Group 5971",
    transform: "translate(-1049 -1131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2521",
    d: "M0 0H16V16H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 2521",
    transform: "translate(1053 1135)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Rectangle_2518",
    className: "prefix__cls-2",
    "data-name": "Rectangle 2518",
    transform: "translate(1054 1140)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 11,
    className: "prefix__cls-4",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 9,
    x: 1,
    y: 1,
    className: "prefix__cls-1",
    rx: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_429",
    fill: "none",
    stroke: "#fed148",
    strokeLinecap: "round",
    strokeWidth: "2px",
    d: "M0 0L5 0",
    "data-name": "Line 429",
    transform: "translate(1058.5 1144.5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Rectangle_2519",
    className: "prefix__cls-2",
    "data-name": "Rectangle 2519"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 0a4 4 0 0 1 4 4v3H0V4a4 4 0 0 1 4-4z",
    className: "prefix__cls-4",
    transform: "translate(1057 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 1a3 3 0 0 1 3 3v1.25a.75.75 0 0 1-.75.75h-4.5A.75.75 0 0 1 1 5.25V4a3 3 0 0 1 3-3z",
    className: "prefix__cls-1",
    transform: "translate(1057 1135)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignin);
export default __webpack_public_path__ + "static/media/icon-signin.7601e1233fe9f5d7595c7c340b886d01.svg";
export { ForwardRef as ReactComponent };